import { Select, SelectChangeEvent, SelectProps, MenuItem, SxProps, Theme } from '@mui/material';
import React, { ReactNode } from "react"

interface SelectOption {
    value: string | number;
    label: string;
}

interface OreveSelectProps extends Omit<SelectProps, 'onChange'> {
    value: string | number;
    options: SelectOption[];
    onChange: (value: string | number) => void;
    sx?: SxProps<Theme>;
    dataCyParent ?: string
    dataCyOption ?: string
}

const selectStyles = {
    width: '100%',
    maxWidth: '100%',
    minWidth: '120px',
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
    '& .MuiSelect-select': {
        backgroundColor: 'grey.100',
        color: 'primary.main',
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: 1.33,
        letterSpacing: '0.03rem',
        py: '0.313rem',

        '&:focus': {
            backgroundColor: 'grey.100'
        }
    },
    '& .MuiSelect-icon': {
        color: 'primary.main'
    }
};

const menuItemStyles = {
    backgroundColor: 'grey.100',
    color: 'primary.main',
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.33,
    letterSpacing: '0.03rem',
    py: '0.313rem',
    '&:hover': {
        backgroundColor: 'grey.200'
    }
};

export const OreveSelect = React.forwardRef<HTMLDivElement, OreveSelectProps>(
    ({
         value,
         options,
         onChange,
         sx = {},
         dataCyParent,
         dataCyOption,
         ...props
     }, ref) => {

        const handleChange = (event: SelectChangeEvent<unknown>) => {
        onChange(event.target.value as string | number);
    };

    const renderSelected = (selected: unknown): ReactNode => {
        if (typeof selected === 'string' || typeof selected === 'number') {
            return options.find(opt => opt.value === selected)?.label || String(selected);
        }
        return null;
    };

    return (
        <Select
            ref={ref}
            value={value}
            onChange={handleChange}
            sx={{ ...selectStyles, ...sx }}
            renderValue={renderSelected}
            data-cy={dataCyParent}
            {...props}
        >
            {options
                .map((item) => (
                    <MenuItem
                        key={item.value.toString()}
                        value={item.value}
                        sx={{
                            ...menuItemStyles,
                            display: item.value === value ? "none" : "block",
                        }}
                        data-cy={`${dataCyOption}--${item.value}`}
                    >
                        {item.label}
                    </MenuItem>
                ))}
        </Select>

    );
});

OreveSelect.displayName = 'OreveSelect';